<div class="login-wrapper">
  <div class="login-card">
    <form [formGroup]="loginForm" (ngSubmit)="login()">
      <!-- Logo (mobile/tablet only) -->
      @if (screenType !== 'MONITOR') {
        <div class="login-logo">
          <img src="/assets/logo-small.png" alt="Hospo Fresh" />
        </div>
      }

      <h2 class="login-title">Welcome back</h2>
      <p class="login-subtitle">Sign in to your account to continue</p>

      @if (loginError.length > 0) {
        <p-message severity="error" [text]="loginError.join(', ')"></p-message>
      }

      <!-- Email -->
      <div class="form-field">
        <label for="email">Email</label>
        <input
          pInputText
          id="email"
          formControlName="email"
          placeholder="you@company.com"
          class="w-100"
        />
        @if (
          loginForm.controls['email'].invalid &&
          (loginForm.controls['email'].touched || loginForm.controls['email'].dirty) &&
          loginForm.controls['email'].errors
        ) {
          <small class="field-error">Please enter a valid email address.</small>
        }
      </div>

      <!-- Password -->
      <div class="form-field">
        <label for="password">Password</label>
        <p-password
          [feedback]="false"
          [toggleMask]="true"
          [style]="{ width: '100%' }"
          [inputStyle]="{ width: '100%' }"
          formControlName="password"
          placeholder="Enter your password"
        ></p-password>
        @if (
          loginForm.controls['password'].invalid &&
          (loginForm.controls['password'].touched || loginForm.controls['password'].dirty)
        ) {
          <small class="field-error">Please enter a valid password.</small>
        }
      </div>

      <!-- Forgot password -->
      <div class="forgot-row">
        <a routerLink="/forgot-password" class="forgot-link">Forgot your password?</a>
      </div>

      <!-- Submit -->
      <button
        type="submit"
        class="btn btn-primary login-btn"
        [disabled]="loginForm.invalid || (isLoading$ | async) === true"
      >
        @if ((isLoading$ | async) === true) {
          <span
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
        }
        Sign In
      </button>
    </form>
  </div>
</div>
